import React from "react";
import { LegalLayout } from "../../components/LegalLayout";
import { LEGAL } from "../../lib/legal";

export default function Cookies() {
  return (
    <LegalLayout title="Cookie Policy" testid="legal-cookies-page">
      <p>
        This Cookie Policy explains the limited use of cookies and similar technologies on {LEGAL.companyName}. We use
        cookies only for essential functionality. We do <strong>not</strong> use advertising, third-party tracking, or
        cross-site analytics cookies.
      </p>

      <h2>What we use</h2>
      <ul>
        <li><strong>access_token</strong> (httpOnly, SameSite=Lax): authenticates you with our backend. Required for login. Cleared on logout.</li>
        <li><strong>refresh_token</strong> (httpOnly, SameSite=Lax): allows your session to be refreshed safely. Cleared on logout.</li>
        <li><strong>Browser localStorage / sessionStorage</strong> (first-party only): stores your preferred trading mode (paper/live), Bearer-token fallback, and short-lived state like "spawn-bot-from-signal" context. Cleared by you at any time via your browser.</li>
      </ul>

      <h2>What we do NOT use</h2>
      <ul>
        <li>Advertising cookies</li>
        <li>Cross-site tracking pixels</li>
        <li>Third-party analytics (Google Analytics, etc.)</li>
        <li>Social media tracking</li>
      </ul>

      <h2>Controlling cookies</h2>
      <p>
        You can disable cookies in your browser settings, but the Service will not function without the essential
        cookies above. To delete all data we hold about you, use the in-app data deletion in Settings.
      </p>

      <h2>Changes</h2>
      <p>If we add any new cookie use, this Policy will be updated and the change announced in-app.</p>
    </LegalLayout>
  );
}
